import { withSvgIcon } from './withSvgIcon';

export const Block = withSvgIcon(
  <path
    d="M12 11L19.8375 7.13021M12 11L4 7M12 11V21M13.7032 3.8015L18.2032 5.91915C19.3193 6.44437 19.8773 6.70698 20.1887 7.19757C20.5 7.68817 20.5 8.30492 20.5 9.53842V14.5917C20.5 15.7649 20.5 16.3515 20.2134 16.8274C19.9268 17.3034 19.4084 17.5779 18.3716 18.1268L13.8715 20.5092C12.955 20.9944 12.4968 21.237 12 21.237C11.5032 21.237 11.045 20.9944 10.1284 20.5092L5.62845 18.1268C4.5916 17.5779 4.07318 17.3034 3.78659 16.8274C3.5 16.3515 3.5 15.7649 3.5 14.5917V9.53842C3.5 8.30492 3.5 7.68817 3.81133 7.19757C4.12267 6.70698 4.68072 6.44437 5.79681 5.91915L10.2968 3.8015C11.1342 3.40743 11.5529 3.21039 12 3.21039C12.4471 3.21039 12.8658 3.40743 13.7032 3.8015Z"
    stroke="currentColor"
    strokeWidth="currentWidth"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
